import {Injectable} from '@angular/core';
import {appInjector} from '../../app.module';
import {APP_ROUTES} from '../../../environments/environment';
import {ConfigurationObject} from '../../interfaces/interfaces.regisafe';
import {StorageService} from '../storage/storage.service';
import {AppConfig} from '../../app.config';
import {IQApiService} from '../iqapi/iqapi.service';
import {ErrorHandlingService} from '../error-handling/error-handling.service';
import {UserService} from '../user/user.service';
import {Router} from '@angular/router';

/**
 * IntentService handles the handling of deep links and navigation based on the passed deep links.
 *
 * @@Injectable
 * @providedIn 'root'
 */
@Injectable({
    providedIn: 'root'
})
export class AndroidIntentService {

    public configuration: ConfigurationObject;
    public deeplinkSchema = 'regisafe://';

    storageService: StorageService = appInjector.get(StorageService);
    appConfig: AppConfig = appInjector.get(AppConfig);
    iqAPI: IQApiService = appInjector.get(IQApiService);
    errorHandling: ErrorHandlingService = appInjector.get(ErrorHandlingService);
    userService: UserService = appInjector.get(UserService);
    router: Router = appInjector.get(Router);

    constructor() {
        this.configuration = this.appConfig.getConfig();
    }

    /**
     * Handles the deeplinks received by the application.
     *
     * @param applink - The deeplink to be handled.
     */
    handleDepplinks(applink: string): void {
        const deeplinkHandling = async (deepLink): Promise<void> => {
            const dlParams = deepLink.split(this.deeplinkSchema)[1];
            const dlParamsArray = dlParams.split('/');
            const dlType: string = dlParamsArray[0]; // object
            const dlHash: string = dlParamsArray[1]; // hash
            const dlUUID: string = dlParamsArray[2]; // uuid


            const orgasructureFromLink: string = await this.storageService.getOrgastructureFromHash(dlHash);

            if (!orgasructureFromLink) {
                this.errorHandling.errorMessage('Unbekannte Orgastruktur. Die Anfrage kann nicht ausgeführt werden', 'toast', true);
            } else {
                const body: any = {};
                body.apiID = this.configuration.iqapiAppId;
                body.sessionToken = this.storageService.getToken();
                body.osId = [orgasructureFromLink];
                body.searchText = '';
                body.searchFields = {
                    ['_UUID']: dlUUID
                };

                const result = await this.iqAPI.orgaManagerSearchObjectsEx(body)
                    .toPromise()
                    .catch((e) => {
                        this.errorHandling.handleError(e, 'appUrlOpen');
                    });
                // eslint-disable-next-line no-underscore-dangle
                const objId = this.userService.objIdAsRouteParam(result.objDatasets[0]._ObjID);
                this.router.navigate([APP_ROUTES.detail, orgasructureFromLink, objId])
                    .then((data) => {
                    });
            }
        };
        deeplinkHandling(applink);
    }
}

